import React, { useEffect, useState, useMemo } from "react";
import DataTable from "react-data-table-component";
import jsPDF from "jspdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../style/userloginhistory.css";
import "../../style/designer-milling-responsive.css";
import { apiAxios } from "../../utils/apiAxios";
import { getAuthToken, getUserIdFromToken } from "../../utils/auth";
import Select from "react-select";

import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
interface OrderRow {
  orderId: number;
  clinic: string;
  type: string;
  assignedHub: string;
  assignedDesigner: string;
  partner: string;
  paymentType: string;
  paymentStatus: string;
  expectedDelivery: string;
  phone: string;
  payment: number;
  status: string;
}
interface OrderType {
  orderTypeID: number;
  orderTypeName: string;
}

const MillingReport = () => {
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [filters, setFilters] = useState({
    orderId: "",
    clinic: "",
    type: "",
    hub: "",
    designer: "",
    partner: "",
    paymentType: "",
    paymentStatus: "",
    fromDate: "",
    toDate: "",
  });
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const [orders, setOrders] = useState<OrderRow[]>([]);
  const [loading, setLoading] = useState(false);

  const [orderCounts, setOrderCounts] = useState({
    activeOrders: 0,
    pendingReview: 0,
    needAttention: 0,
    completed: 0,
  });
  const [orderDropdown, setOrderDropdown] = useState<{ caseID: number; orderID: string }[]>([]);


  const [orderTypes, setOrderTypes] = useState<OrderType[]>([]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const orderOptions = useMemo(
  () =>
    [...(orderDropdown || [])]
      .sort(
        (a: any, b: any) =>
          new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
      )
      .map((item: any) => ({
        value: item.orderID,
        label: `${item.orderID} - ${new Date(
          item.createdDate
        ).toLocaleDateString("en-GB")}`,
      })),
  [orderDropdown]
);
  const handleClear = () => {
    setFilters({
      orderId: "",
      clinic: "",
      type: "",
      hub: "",
      designer: "",
      partner: "",
      paymentType: "",
      paymentStatus: "",
      fromDate: "",
      toDate: "",
    });

    setSearch("");
    setStartDate(null);
    setEndDate(null);
    setOrders([]);
  };
  useEffect(() => {
    //fetchOrderCounts();
    fetchOrderDropdown();
    fetchOrderTypes();
  }, []);


  const fetchReport = async () => {
    try {
      setLoading(true);

      const payload = {
        OrderID: filters.orderId || null,
        OrderTypeID: filters.type ? Number(filters.type) : null,  // ✅ FIX
        FromDate: startDate ? startDate.toISOString() : null,
        ToDate: endDate ? endDate.toISOString() : null,
        Search: search?.trim() ? search : null,
      };
      const res = await apiAxios.post(
        `${API_BASE_URL}/MillingHub/get-report`, payload);

      if (res.data?.isSuccess) {
        const mapped = (res.data.singleData || []).map((item: any) => ({
          orderId: item.orderID,
          clinic: item.clinicName || "",
          type: item.orderType || "",
          assignedHub: item.hubName || "",
          assignedDesigner: item.designerName || "",
          partner: item.deliveryPartner || "",
          paymentType: item.paymentType || "",
          paymentStatus: item.paymentStatus || "",
          expectedDelivery: item.expectedDelivery || "",
          phone: item.phone || "",
          payment: item.amount || 0,
          status: (item.status || "").toUpperCase(),
        }));

        setOrders(mapped);
      }
    } catch (err) {
      console.error("Milling report error:", err); // ✅ updated label
    } finally {
      setLoading(false);
    }
  };
  const fetchOrderTypes = async () => {
    try {
      const token = getAuthToken();

      const res = await apiAxios.get(
        `${API_BASE_URL}/MillingHub/order-type-dropdown`,
        {
          headers: { AuthorizationData: token },
        }
      );

      if (res.data?.data) {
        setOrderTypes(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load order types", err);
    }
  };
  const fetchOrderDropdown = async () => {
    try {
      const token = getAuthToken();
      const userId = getUserIdFromToken();

      const res = await apiAxios.get(
        `${API_BASE_URL}/MillingHub/order-dropdownMillingReport`,
        {
          params: { userId: userId },
          headers: { AuthorizationData: token },
        }
      );

      if (res.data?.data) {
        setOrderDropdown(res.data.data);
      }
    } catch (err) {
      console.error("Failed to load order dropdown", err);
    }
  };
  const fetchOrderCounts = async () => {
    try {
      const token = getAuthToken();
      const res = await apiAxios.get(`${API_BASE_URL}/MillingHub/GetOrderCounts`, {
        headers: { AuthorizationData: token },
      });
      const data = res.data?.data?.[0];
      if (data) {
        setOrderCounts({
          activeOrders: data.activeOrders ?? 0,
          pendingReview: data.pendingReview ?? 0,
          needAttention: data.needAttention ?? 0,
          completed: data.completed ?? 0,
        });
      }
    } catch (err) {
      console.error("Failed to load order counts", err);
    }
  };

  const columns = useMemo(
    () => [
      {
        name: "Order ID",
        selector: (row: OrderRow) => row.orderId,
        sortable: true,
      },

      {
        name: "Type",
        selector: (row: OrderRow) => row.type,
      },

      {
        name: "Status",
      width:"190px",
        cell: (row: OrderRow) => {
          const statusStyles: Record<string, { bg: string; color: string }> = {
             completed: { bg: "#d1fae5", color: "#065f46" },
      ready_for_delivery: { bg: "#dbeafe", color: "#1e40af" },
      pending_acceptance: { bg: "#fef3c7", color: "#92400e" },
      delay_report: { bg: "#fee2e2", color: "#991b1b" },
      pending: { bg: "#f3f4f6", color: "#374151" },
     out_for_delivery: { bg: "#3B82F6", color: "#fff" },
      delivered: { bg: "#22c55e", color: "#fff" },
      cancelled: { bg: "#dc3545", color: "#fff" },

   under_review: { bg: "  #FFCD39", color: "#000" }
          };

          const status = (row.status || "")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_");

          const style = statusStyles[status] || {
            bg: "#f3f4f6",
            color: "#374151",
          };

          return (
            <span
              style={{
                backgroundColor: style.bg,
                color: style.color,
                padding: "5px 10px",
                borderRadius: "4px",
                fontSize: "12px",
                fontWeight: 500,
                display: "inline-block",
                textTransform: "capitalize",
                whiteSpace: "nowrap",
              }}
            >
              {row.status || "-"}
            </span>
          );
        },
        
      }
    ],
    []
  );

  const exportExcel = () => {
    const exportData = orders.map((d) => ({
      "Order ID": d.orderId,
      "Type": d.type,
      "Status": d.status,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Admin Report");

    XLSX.writeFile(workbook, "Milling_Report.xlsx");
  };

const exportPDF = () => {
  const doc = new jsPDF("landscape");

  // =========================
  // REPORT HEADING
  // =========================
  const pageWidth = doc.internal.pageSize.getWidth();

  doc.setFontSize(18);
  doc.setFont("helvetica", "normal");

  doc.text(
    "Milling Order Report",
    pageWidth / 2,
    15,
    { align: "center" }
  );

  // =========================
  // TABLE
  // =========================
  const tableColumn = [
    "Order ID",
    "Type",
    "Status",
  ];

  const tableRows = orders.map((d) => [
    d.orderId,
    d.type,
    d.status,
  ]);

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,

    // Heading ke neeche table
    startY: 25,

    styles: {
      fontSize: 8,
      halign: "center",
      valign: "middle",
    },

    headStyles: {
      fillColor: [22, 160, 133],
      halign: "center",
    },
  });

  doc.save("Milling_Report.pdf");
};
  const totalOrders = orders.length;


  const completedOrders = orders.filter(
    (x) => (x.status || "").toLowerCase() === "completed"
  ).length;

  const cancelledOrders = orders.filter(
    (x) => (x.status || "").toLowerCase().includes("cancelled")
  ).length;

  const pendingOrders = orders.filter((x) => {
    const status = (x.status || "").toLowerCase();
    return status !== "completed" && !status.includes("cancelled");
  }).length;




  return (
    <div className="container-fluid mt-3">
      <div className="mb-4">
        <h4 className="mb-4">Milling Order Report</h4>
        <p className="text-muted">
          Track all orders
        </p>
      </div>

      {/**************new cards sections  */}
      <div className="order-status-bar mb-4">

        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>
        </div>

        <div className="status-col">
          <h3>{pendingOrders}</h3>
          <div className="status-badge warning">
            <i className="bi bi-clock-history"></i>
            Pending
          </div>
        </div>

        <div className="status-col">
          <h3>{completedOrders}</h3>
          <div className="badge-box badge-success">
            <i className="bi bi-check-circle-fill completed-icon"></i>
            Completed
          </div>
        </div>

        <div className="status-col">
          <h3>{cancelledOrders}</h3>
          <div className="status-badge danger">
            <i className="bi bi-x-circle-fill"></i>
            Cancelled
          </div>
        </div>
      </div>

      {/* FILTER PANEL */}

      <div className="premium-card mb-4 p-3">

        <div className="row g-3 align-items-end">
          {/* Order ID */}
          <div className="col-md-12  col-12 col-sm-12 col-lg-3">
                  <label className="form-label">Order ID</label>
           <Select
 options={orderOptions}
  value={
    orderDropdown
      .map((item) => ({
        value: item.orderID,
        label: `OrderID-${item.orderID}`,
      }))
      .find((opt) => opt.value === filters.orderId) || null
  }
  onChange={(selected) =>
    setFilters((prev) => ({
      ...prev,
      orderId: selected ? String(selected.value) : "",
    }))
  }
  placeholder="Select Order ID"
  isSearchable
  isClearable
  classNamePrefix="react-select"
/>
          </div>

         <div className="col-md-12 col-12 col-sm-12 col-lg-3">
  <label className="form-label">Order Type</label>

  <Select
    options={orderTypes.map((item) => ({
      value: Number(item.orderTypeID),
      label: item.orderTypeName,
    }))}
    value={
      orderTypes
        .map((item) => ({
          value: Number(item.orderTypeID),
          label: item.orderTypeName,
        }))
        .find((item) => item.value === Number(filters.type)) || null
    }
    onChange={(selected) =>
      setFilters((prev) => ({
        ...prev,
        type: selected ? String(selected.value) : "",
      }))
    }
    placeholder="Select Type"
    isSearchable
    isClearable
    menuPortalTarget={document.body}
    styles={{
      menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
      }),
    }}
  />
</div>

          {/* Start Date */}
          <div className="col-md-12  col-12 col-sm-12 col-lg-3 position-relative">
                  <label className="form-label">Start Date</label>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              placeholderText="Start Date"
              className="form-control pe-5"
              dateFormat="dd-MM-yyyy"
              portalId="root"
            />
                <i className="bi bi-calendar3 calendar-icon mtcustom"></i>
          </div>

          {/* End Date */}
          <div className="col-md-12  col-12 col-sm-12 col-lg-3 position-relative">
                 <label className="form-label">End Date</label>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              placeholderText="End Date"
              className="form-control pe-5"
              dateFormat="dd-MM-yyyy"
              portalId="root2"
            />
                <i className="bi bi-calendar3 calendar-icon mtcustom"></i>
          </div>

          {/* Search */}
          <div className="col-md-4 col-lg-3">
               <label className="form-label">Search</label>
            <input
              className="form-control"
              placeholder="Global Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Buttons (aligned bottom) */}
          <div className="col-md-4 col-lg-3 d-flex gap-2">

            <button type="button" className="btn btn-primary"
              onClick={fetchReport}>
              Search
            </button>

            <button type="button"
              className="btn btn-secondary   d-flex align-items-center"
              onClick={handleClear}
            >
              Clear
            </button>

          </div>

        </div>

      </div>





      {/* TABLE */}

      <div className="premium-card p-4 round">
        <div className="d-flex justify-content-end gap-2 mb-3">

          <button type="button"
            className="btn btn-success"
            onClick={exportExcel}
            disabled={orders.length === 0}
          >
            <i className="bi bi-file-earmark-excel me-2"></i>
            Export Excel
          </button>

          <button type="button"
            className="btn btn-danger"
            onClick={exportPDF}
            disabled={orders.length === 0}
          >
            <i className="bi bi-file-earmark-pdf me-2"></i>
            Export PDF
          </button>

        </div>
        <DataTable
          columns={columns}
          data={orders}
          pagination
          highlightOnHover
          striped
          responsive
          fixedHeader
          fixedHeaderScrollHeight="500px"
          className="admin-delivery-table"
        />
      </div>
    </div>
  );
};

export default MillingReport;